import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';


export const submitInspectionOther = (data) => {

  return axios.post(api.SUBMIT_INSPECTION_OTHER, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

    })
    .catch((err) => {
      console.error('SUBMIT_INSPECTION_OTHER returns error:');
      console.error(err);
    });
};
